import React from 'react';

import { NavigatorNumberLink } from './NavigatorNumber.styled';
import { utils } from 'kb-shared';

export const NavigatorNumber = () => {
  return (
    <NavigatorNumberLink href={`tel:${utils.KBContacts.navigatorNumber}`}>
      {utils.KBContacts.navigatorNumber}
    </NavigatorNumberLink>
  );
};
